import { useMediaQuery } from "./useMediaQuery";

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

export function useIsMobile(below: Breakpoint = "md"): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS[below] - 1}px)`);
}

export function useIsAtLeast(breakpoint: Breakpoint): boolean {
  return useMediaQuery(`(min-width: ${BREAKPOINTS[breakpoint]}px)`);
}
